<div *ngIf="showViewHTMLComponent">
  <div *ngIf="originalData.length > 0">
    <div class="search-results-bar">
      <input type="text" class="search-input-results" (input)="applyFilter()" placeholder="Buscar" name="filtro"
        [(ngModel)]="filterTerm">
      <button class="search-button" (click)="applyFilter()">
        <span class="material-symbols-outlined">
          search
        </span>
      </button>
    </div>
    <div id="data-table-component" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>
              <div (click)="sortTable('vigencia')">
                <span>Años</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'vigencia'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('periodo')">
                <span>Periodo</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'periodo' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'periodo' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'periodo'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('estado')">
                <span>Estado</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'estado' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'estado' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'estado'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('saldoImpuesto')">
                <span>Impuesto</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'saldoImpuesto' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'saldoImpuesto' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'saldoImpuesto'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('interes')">
                <span>Interés</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'interes' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'interes' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'interes'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('sancion')">
                <span>Sanción</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'sancion' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'sancion' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'sancion'">unfold_more</span>
              </div>
            </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedData">
            <td>{{item.vigencia}}</td>
            <td>{{item.periodo}}</td>
            <td>{{item.estado }}</td>
            <td>{{item.saldoImpuesto | currency:'COP':'$':'1.0-0'}}</td>
            <td>{{item.interes | currency:'COP':'$':'1.0-0' }}</td>
            <td>{{item.sancion | currency:'COP':'$':'1.0-0'}}</td>
            <td>
              <div class="cell-table-actions">
                <a href="javascript:void(0)" class="a-action-primary" *ngIf="item.btnFormulario" (click)="getFormulario(item)">Descargar formulario</a>
                <a href="javascript:void(0)" class="a-action-primary" *ngIf="item.btnLiquidar" (click)="getLiquidar(item)">Liquidar</a>
                <div class="dropdown" *ngIf="item.btnPagar">
                  <span (click)="toggleMenu(item)" class="material-symbols-outlined material-symbols-filled" title="Ver más acciones" style="padding: 0px 20px;cursor: pointer;" [class.active]="item.$$isMenuOpen">
                    more_vert
                  </span>
                  <ul class="dropdown-content" [class.show]="item.$$isMenuOpen">
                    <li><a href="javascript:void(0)" (click)="getPagar(item)"><span class="material-symbols-outlined material-symbols-filled">payments</span>Pagar en Línea</a></li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="paginatedData.length == 0 && originalData.length > 0" >
            <td colspan="7" style="text-align: center;">
              No se encontraron resultados asociados a tu búsqueda.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" *ngIf="pageNumbers.length != 0 && this.originalData.length > this.rowsPerPage">
      <span class="pagination-text control_boton_paginacion_1" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">Anterior</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">arrow_back_ios</span>
      <ng-container *ngFor="let page of pageNumbers">
        <button *ngIf="page !== '...'; else ellipsis" class="page-button" [class.active]="page === currentPage"
          (click)="goToPage(page)"> {{page}}</button>
        <span>
        </span>
        <ng-template #ellipsis>
          <span class="ellipsis enabled-control-button w700">...</span>
        </ng-template>
      </ng-container>
      <span class="pagination-text control_boton_paginacion_1" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">Siguiente</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">arrow_forward_ios</span>
    </div>
  </div>
  <div class="container-body-tab-item-result" *ngIf="originalData.length == 0">
    <div class="container-body-tab-item-result-view">
      <span class="material-symbols-outlined material-symbols-filled header-icon alert-info">event_available</span>
      <p class="header-icon-title alert-info" >Sin obligaciones pendientes.</p>
      <p class="body-seccion">No encontramos obligaciones por pagar en este momento.<br> Cuando se generen nuevas obligaciones, aparecerán aquí para que las gestiones fácilmente.</p>
    </div>
  </div>
</div>